// Container related components
import styled from 'styled-components';

export const ItemsContainer = styled.div<{ minimized: boolean, minimizedHeight: number, fullHeight?: number }>`
  overflow: hidden;
  transition: height 300ms;
`;
